import { styled } from "goober";

export const SettingsModalHeader = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
`;

export const HeaderIconContainer = styled("div")`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--alpha4);
  border-radius: 8px;
  flex-shrink: 0;
`;

export const HeaderRight = styled("div")`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export const SettingsModalBody = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
  padding: 16px;
  overflow-y: auto;
  border-top: 0.5px solid var(--border-alpha);
`;

export const SettingsModalFooter = styled("div")`
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  border-top: 0.5px solid var(--border-alpha);
`;
